// extracted by mini-css-extract-plugin
export default {"container":"FloorChangingAlert_container__LK9id","text":"FloorChangingAlert_text__8+ZuS"};